import { Box, Button, Grid, Pagination, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import api_service from "../../../network/api_callbacks";
import Loader from '../../../utility/Loader';
import MultimediaItem from "./MultimediaItem ";

const RapHousieMultimedia = (props) => {

    const navigate = useNavigate();
    const location = useLocation();
    const isCreatePage = location.pathname.includes("create-raphousie-multimedia");
    const pathname = location.pathname;
    const state = location.state;
    console.log("location : ", location);
    console.log("location.pathname : ", pathname);
    console.log("location.state : ", state);

    const DEFAULT_PAGINATION_ITEM_COUNT = 30;
    const DEFAULT_PAGINATION_PAGE = 1;
    const [page, setPage] = useState(DEFAULT_PAGINATION_PAGE);
    const [loader, setLoader] = useState(false);
    const [tambolaMultimediaList, setTambolaMultimediaList] = useState([]);
    const [tambolaMultimediaPaginationData, setTambolaMultimediaPaginationData] = useState(null);

    useEffect(() => {
        if (state?.shouldRefresh) {
            getTambolaMultimediaList();
        }
    }, [state?.shouldRefresh]);

    useEffect(() => {
        if (!tambolaMultimediaPaginationData && tambolaMultimediaList?.length === 0) {
            getTambolaMultimediaList();
        }
    }, []);

    const getTambolaMultimediaList = async (pageToFetch = page) => {
        setLoader(true);
        try {
            const response = await api_service.getTambolaMultimediaList({ _page: pageToFetch, _limit: DEFAULT_PAGINATION_ITEM_COUNT });

            const listData = response?.data;
            const paginationData = response?.pagination;

            console.log('📘 response :', response);
            console.log('📘 listData :', listData);
            console.log('📘 paginationData :', paginationData);

            // const enrichedListData = await Promise.all(
            //     listData.map(async (item) => {
            //         try {
            //             const videoId = extractVimeoId(item?.videoUrl);
            //             const { progressiveLink, playLink, videoData } = await getVimeoPlayLink(videoId);
            //             const updateMultimediaItem = { ...item, progressiveLink, videoData };
            //             return updateMultimediaItem;
            //         } catch (err) {
            //             console.error("❌ Failed to get vimeo link for item:", item?._id, err);
            //             return { ...item };
            //         }
            //     })
            // );

            // const duplicatedList = Array.from({ length: 10 }, (_, i) =>
            //     enrichedListData.map((item, idx) => ({
            //         ...item,
            //         _id: `${item._id || "item"}_${i + 1}_${idx + 1}`,
            //         duplicateIndex: i + 1,
            //     }))
            // ).flat();

            console.log("length : ", listData?.length)
            setTambolaMultimediaList(listData || []);
            setTambolaMultimediaPaginationData(paginationData);
            setPage(pageToFetch);

            setLoader(false);
        } catch (error) {
            console.error('❌ Failed to fetch getActiveStats:', error);
        }
    }

    const ShowMultimediaList = () => {
        const [activeVideoId, setActiveVideoId] = useState(null);
        return (
            <Grid container spacing={2} justifyContent="center" alignItems="center" marginBottom={4}>
                {tambolaMultimediaList?.map((item) => {
                    return (
                        <MultimediaItem
                            key={item?._id}
                            item={item}
                            isActive={activeVideoId === item?._id}
                            onPlay={() => setActiveVideoId(item?._id)}
                            onClick={() => navigateToDetailOrEditMultimedia(item)}
                        />
                    )
                })}
            </Grid>
        )
    }

    const navigateToCreateMultimedia = () => {
        navigate("create-raphousie-multimedia", {
            state: { listData: tambolaMultimediaList },
        })
    }

    const navigateToDetailOrEditMultimedia = (item) => {
        navigate("create-raphousie-multimedia", {
            state: { multimediaDetail: item },
        })
    }

    return (
        <>
            {!isCreatePage ?
                <Box sx={{
                    flex: 1,
                    height: '100%',
                    display: "flex",
                    padding: 0,
                    flexDirection: "column",
                    gap: 0,
                    marginBottom: 4,
                    position: "relative",
                    overflow: "auto"
                }}>

                    <Box sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 2,
                        padding: 4,
                        position: "sticky",   // ✅ stick within parent container
                        top: 0,               // ✅ stick to the top
                        zIndex: 5,            // ✅ ensure it stays above content
                        backgroundColor: "#fff",
                        borderBottom: "1px solid #ddd", // optional for visual separation
                    }}>

                        <Typography variant="h5" sx={{ mt: 0, fontWeight: 700, textAlign: 'end' }}>Rap Housie Multimedia</Typography>

                        <Button
                            variant="contained"
                            color="success"
                            sx={{ borderRadius: 2, textTransform: "none", mr: 0, height: 40, width: 'auto' }}
                            onClick={() => {
                                //onCreateClick();
                                navigateToCreateMultimedia();
                            }}
                        >
                            Create Multimedia
                        </Button>
                    </Box>

                    <ShowMultimediaList />

                    {/* Pagination */}
                    <Box sx={{ display: "flex", justifyContent: "center", mt: 0 }}>
                        {tambolaMultimediaPaginationData && (
                            <Pagination
                                count={tambolaMultimediaPaginationData?.totalPages || 1}
                                page={page}
                                onChange={(_, newPage) => getTambolaMultimediaList(newPage)}
                                color="primary"
                                size="large"
                                variant="outlined"
                                shape="rounded"
                                sx={{
                                    mt: 2,
                                    "& .MuiPaginationItem-root": {
                                        borderRadius: "8px",
                                        fontWeight: "bold",
                                        color: "#444",
                                    },
                                    "& .Mui-selected": {
                                        backgroundColor: "#1976d2 !important",
                                        color: "#fff",
                                        boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                                    },
                                    "& .MuiPaginationItem-root:hover": {
                                        backgroundColor: "rgba(25, 118, 210, 0.1)",
                                    },
                                }}
                            />
                        )}
                    </Box>

                    {/* ✅ Loader overlay in center */}
                    {loader && (
                        <Box
                            sx={{
                                position: "fixed", // ✅ fixed to viewport
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                background: "rgba(255,255,255,0.6)",
                                zIndex: 1300, // higher than sticky header

                                // position: "absolute",
                                // top: "50%",
                                // left: "50%",
                                // transform: "translate(-50%, -50%)", // ✅ Center correctly
                                // display: "flex",
                                // justifyContent: "center",
                                // alignItems: "center",
                                // background: "rgba(255,255,255,0.6)",
                                // zIndex: 10,
                                // width: "100%",
                                // height: "100%",
                            }}
                        >
                            <Loader />
                        </Box>)}
                </Box>
                :
                <Outlet />}
        </>
    );
}

const mapStateToProps = (state) => {
    return {

    }
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(RapHousieMultimedia)